
import { computed, defineComponent } from 'vue';

export default defineComponent({
	name: 'OrderSummaryLine',
	props: {
		label: { type: String },
		value: { type: [String, Number], required: true },
		isSavings: { type: Boolean },
		withMinus: { type: Boolean, default: true },
		semiBold: { type: Boolean, default: true },
		qaData: { type: String, default: "" },
		amountIsHidden: Boolean,
	},
	setup(props) {
		return {
			valueString: computed(() => {
				if (props.amountIsHidden) {
					return props.value;
				}

				return typeof props.value === 'number' ?  (props.withMinus ? '-' : '') + '$' +  props.value.toFixed(2) : props.value;
			}),
		};
	}
});
